import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EcommService } from "src/app/services/ecomm.service";
import { constApi } from "src/environments/constApi";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.sass"],
})
export class FooterComponent implements OnInit {
  constructor(private ecomService: EcommService, private fb: FormBuilder) {}
  fbSubscribir: FormGroup;
  valuesEcom: any[] = [];
  cuentasArray: any[] = [];
  ngOnInit() {
    this.getValEcom();
    this.buildForm();
    this.cargarCuentasBanco()
  }

  buildForm() {
    this.fbSubscribir = this.fb.group({
      email: [''],
    });
  }

  getValEcom() {
    let param = [{ clave: "Tipo", valor: "VALECOM" }];
    this.ecomService
      .getParam(environment.apiUrlAdm,constApi.ENUMTIPO, param)
      .subscribe((res: any) => {
        this.valuesEcom = res.filter((x) => x.ValorI != 1);
        this.valuesEcom.sort(function (a, b) {
          if (a.ValorI > b.ValorI) {
            return 1;
          }
          if (a.ValorI < b.ValorI) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      });
  }

  subscribirCliente() {
    //console.log(this.fbSubscribir.get("email").value);
    //console.log("click aqui");
    let param = {
      idSuscrito: 0,
      eMail: this.fbSubscribir.get("email").value,
    };

    this.ecomService
      .createSinTk(environment.apiUrl,constApi.SUSCRITOS, param)
      .subscribe((res: any) => {
        //console.log(res);
        this.fbSubscribir.get("email").setValue("");
        alert("Gracias por suscribirse");
      });
  }
  cargarCuentasBanco(){
    let param = [
      {clave:'Filial',valor:'NP'}
    ]
    this.ecomService.getParam(environment.apiUrlTeso,constApi.CTASBANCOS, param).subscribe((res: any) => {
      this.cuentasArray = res.filter(y => y.Habilitado);
      this.cuentasArray.forEach(x => {
        switch (x.SiglasBco) {
          case 'BCP':
            x.Img = "https://novaplaza.pe/assets/images/bcp.png"
          break;
          case 'BBVA':
            x.Img = "https://novaplaza.pe/assets/images/continental.png"
          break;
          case 'BVL':
            x.Img = "https://novaplaza.pe/assets/images/interbank.png"
          break;
        }
      })
      this.cuentasArray.push({
        SiglasBco: "YP",
        NombreBco: "Yape",
        CuentaB: "977 691 452",
        Img: "https://novaplaza.pe/assets/images/yape.png",
      })
    });
  }
}
